
import routerLink from '@/router-link'
import SectionTitle from '~/sections/vision/section-title.vue'

export default {
  name: 'AiWorkspaceProgram',
  components: {
    SectionTitle
  },
  computed: {
    routerLink() {
      return routerLink
    }
  }
}
